import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/modules/modal';
import '@archetype-themes/scripts/helpers/sections';

class StockLevelModal extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.stock_level__modal--trigger');

    document.addEventListener('variant:change', this.handleVariantChange.bind(this));

    button.addEventListener('click', (e) => {
      e.preventDefault();
      this.id = button.getAttribute('data-id');
      this.content = document.querySelector(`#page-content-${this.id}`);
      this.exitButton = document.querySelector(`#${this.id} [data-close-button]`);
      this.init();
    });
  }

  handleVariantChange(event) {
    this.updateIndicatorTextAndColor(event);
  }

  updateIndicatorTextAndColor(event) {
    const stockLevelInput = this.querySelector('.stock_level__input');
    if (!stockLevelInput) {
      console.error('Stock level input element not found.');
      return;
    }

    const metafieldsElement = this.querySelector('[data-stock-indicator-variants]');
    if (!metafieldsElement) {
      console.error('Metafields element not found.');
      return;
    }

    let metafieldsContent;
    try {
      metafieldsContent = JSON.parse(metafieldsElement.innerHTML);
    } catch (error) {
      console.error('Error parsing metafields content:', error);
      return;
    }

    const selectedVariantId = event.detail.variant.id;

    // Find the selected variant in metafieldsContent
    const selectedVariant = metafieldsContent.find((variant) => variant.id === selectedVariantId);
    if (!selectedVariant) {
      console.error('Selected variant not found in metafields content.');
      return;
    }

    // Update stockLevelInput only when the metafield setting is enabled
    if (stockLevelInput.hasAttribute('data-enable-dynamic-text')) {
      stockLevelInput.innerHTML = selectedVariant.variant_indicator_text;
    }

    // Update indicator color
    const indicatorColor = selectedVariant.variant_color;
    const styleElementId = 'dynamic-indicator-color';

    let styleElement = this.querySelector(`#${styleElementId}`);
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleElementId;
      this.appendChild(styleElement);
    }

    styleElement.innerHTML = `
      .stock_level__container :not(.modal__inner) .icon--inventory.icon--product:after, 
      .stock_level__container :not(.modal__inner) .icon--inventory.icon--product:before {
        background: ${indicatorColor} !important;
      }
    `;
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this.handleVariantChange);
  }

  init() {
    this.modal = new theme.Modals(this.id, this.id, {
      closeOffContentClick: false,
    });
    this.modal.open();
    theme.a11y.lockMobileScrolling();

    if (this.exitButton) {
      this.exitButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.modal.close();
        theme.a11y.unlockMobileScrolling();
      });
    }
  }
}

customElements.define('stock-level-modal', StockLevelModal);
